import { ProgramViewContext } from 'components_v2/page_context'
import React, { useContext, useEffect, useRef } from 'react'
import styled from 'styled-components'

const Main = styled.div`
  .plan-tabs {
    margin: 0 auto;
  }
`

const ItemTab = ({ isActive, href, onClick, title }) => (
  <li onClick={onClick} className={`${isActive ? 'active' : ''}`}>
    <a
      className='underline-effect'
      onClick={(e) => e.preventDefault()}
      href={href}
    >
      {title}
    </a>
  </li>
)
const ProgramTabs = () => {
  const { setTab, tab, plan } = useContext(ProgramViewContext)
  const slug = plan?.slug
  const ref = useRef()
  useEffect(() => {
    const handlePopState = () => {
      const path = window.location.pathname
      if (path.endsWith(`${slug}/workouts`)) {
        setTab('workouts')
      } else {
        setTab('overview')
      }
      ref.current?.scrollIntoView({
        behavior: 'smooth'
      })
    }
    window.addEventListener('popstate', handlePopState)
    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [setTab, slug])

  const handleTabChange = (tb) => {
    setTab(tb.key)
    window.history.pushState({}, '', tb.href)
  }

  return (
    <Main ref={ref} className='container-plan-tabs-outer'>
      <div className='container-16 container-bundle container-plan-tabs'>
        <ul className='nav nav-tabs plan-tabs'>
          {[
            { href: `/series/${slug}`, title: 'Overview', key: 'overview' },
            {
              href: `/series/${slug}/workouts`,
              title: 'Classes',
              key: 'workouts'
            }
          ].map((tb) => (
            <ItemTab
              key={tb.key}
              isActive={tab === tb.key}
              href={tb.href}
              title={tb.title}
              onClick={() => handleTabChange(tb)}
            />
          ))}
        </ul>
      </div>
    </Main>
  )
}

export default ProgramTabs
